import { useSelector } from 'react-redux';
import get from 'lodash/get';

export const useIndexData = () => {
  const userTimeZone = useSelector(({ auth }) => auth?.user?.timezone);
  const isStarting = useSelector(({ nightAssist }) =>
    get(nightAssist, 'isStarting', false)
  );
  const normalTimerRunning = useSelector(
    ({ timer }) => get(timer, 'timerRunning.data') || {}
  );
  const timerRunning = useSelector(
    ({ nightAssist }) => get(nightAssist, 'naTimerRunning.data') || {}
  );

  // hardcode timer to test warning countdown
  // if (timerRunning) {
  //   timerRunning.warned_for = 60 * 4 + 50;
  //   timerRunning.warned_for_hms = '01:00:00';
  // }
  const locationParticipants = useSelector(
    ({ nightAssist }) => get(nightAssist, 'locationParticipants.data') || []
  );
  const stopTimerLoading = useSelector(({ nightAssist }) =>
    get(nightAssist, 'stopNATimer.loading')
  );
  const extendTimerLoading = useSelector(({ nightAssist }) =>
    get(nightAssist, 'extendNATimer.loading')
  );
  const updateTimerLoading = useSelector(({ nightAssist }) =>
    get(nightAssist, 'updateNATimer.loading')
  );
  const submittingNA = useSelector(({ userSettings }) =>
    get(userSettings, 'settings.submittingNA')
  );

  return {
    isStarting,
    normalTimerRunning,
    timerRunning,
    locationParticipants,
    stopTimerLoading,
    extendTimerLoading,
    updateTimerLoading,
    submittingNA,
    userTimeZone,
  };
};
